import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "@/store";
import { listRouterArr } from "./listRouter";
Vue.use(VueRouter);

const routes = [
  ...listRouterArr,

  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/staticQuiz",
    name: "StaticQuiz",
    meta: {
      title: "刷题 · 选择题库",
    },
    component: () => import("@/views/staticQuiz/StaticQuizList.vue"),
  },
  {
    path: "/staticQuiz/play",
    name: "StaticQuizPlay",
    meta: {
      title: "刷题",
    },
    component: () => import("@/views/staticQuiz/StaticQuizPlay.vue"),
  },
  {
    path: "/seatCode",
    name: "/seatCode",
    meta: {
      title: "座位信息",
    },
    component: () => import("@/views/seatCode.vue"),
  },
  {
    path: "/questionAnswer",
    name: "QuestionAnswer",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/QuestionAnswer.vue"),
  },
  {
    path: "/classLearing",
    name: "ClassLearing",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/learning/classLearing.vue"),
  },
  {
    path: "/studentquestionanswer",
    name: "studentquestionanswer",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/studentquestionanswer.vue"),
  },
  {
    path: "/learningQuestionDetail",
    name: "LearningQuestionDetail",
    component: () => import("@/views/learningQuestionDetail.vue"),
  },
  {
    path: "/referenceAnswer",
    name: "ReferenceAnswer",
    component: () => import("@/views/referenceAnswer.vue"),
  },
  {
    path: "/questionItem",
    name: "QuestionItem",
    component: () => import("@/views/questionItem.vue"),
  },
  {
    path: "/editQuestionDetail",
    name: "EditQuestionDetail",
    component: () => import("@/views/editQuestionDetail.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test.vue"),
  },
  {
    path: "/groupChaining",
    name: "groupChaining",
    component: () => import("@/views/groupChaining/index.vue"),
  },
  {
    path: "/wrongQuestion",
    name: "WrongQuestion",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/wrongQuestionBook/wrongQuestion.vue"),
  },
  {
    path: "/wrongQuestionBook",
    name: "WrongQuestionBook",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/wrongQuestionBook/index.vue"),
  },
  {
    path: "/testPaper",
    name: "TestPaper",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/testPaper/index.vue"),
  },
  {
    path: "/paperQuestion",
    name: "PaperQuestion",
    component: () => import("@/views/testPaper/paperQuestion.vue"),
  },
  {
    path: "/showPaper",
    name: "ShowPaper",
    component: () => import("@/views/testPaper/showPaper.vue"),
  },
  {
    path: "/questionnaire",
    name: "Questionnaire",
    component: () => import("@/views/questionnaire/index.vue"),
  },
  {
    path: "/studentLearning",
    name: "StudentLearning",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/learning/studentLearning.vue"),
  },
  {
    path: "/gradeLearning",
    name: "GradeLearning",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/learning/gradeLearning.vue"),
  },
  {
    path: "/settingLearning",
    name: "SettingLearning",
    component: () => import("@/views/learning/settingLearning.vue"),
  },
  {
    path: "/showQuestion",
    name: "ShowQuestion",
    component: () => import("@/views/learning/showQuestion.vue"),
  },
  {
    path: "/studentQuestion",
    name: "StudentQuestion",
    component: () => import("@/views/learning/studentQuestion.vue"),
  },
  {
    path: "/showKnowledge",
    name: "ShowKnowledge",
    component: () => import("@/views/learning/showKnowledge.vue"),
  },
  {
    path: "/userAgreement",
    name: "UserAgreement",
    component: () => import("@/views/userAgreement.vue"),
  },
  {
    path: "/privacyPolicy",
    name: "PrivacyPolicy",
    component: () => import("@/views/privacyPolicy.vue"),
  },
  {
    path: "/downApp",
    name: "DownApp",
    component: () => import("@/views/downApp.vue"),
  },
  {
    path: "/scoreInquiry",
    name: "ScoreInquiry",
    component: () => import("@/views/scoreInquiry.vue"),
  },
  {
    path: "/studyReport",
    name: "StudyReport",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/views/analy/studyReport.vue"),
  },
  {
    path: "/explain",
    name: "Explain",
    component: () => import("@/views/analy/explain.vue"),
  },
  {
    path: "/activityAnswer/question",
    name: "/activityAnswer/question",
    meta: {
      title: "答题",
    },
    component: () => import("@/views/activityAnswer/question.vue"),
  },
  {
    path: "/activityAnswer/lucky",
    name: "/activityAnswer/lucky",
    meta: {
      title: "抽奖",
    },
    component: () => import("@/views/activityAnswer/lucky.vue"),
  },
  {
    path: "/wx/wxLogin",
    name: "/wx/wxLogin",
    meta: {
      title: "微信登录",
    },
    component: () => import("@/views/wx/wxLogin.vue"),
  },
  {
    path: "/alumni",
    name: "AlumniSelect",
    meta: {
      title: "请选择填报内容",
    },
    component: () => import("@/views/alumniSelect/index.vue"),
  },
  {
    path: "/alumni/unit",
    name: "AlumniUnitForm",
    meta: {
      title: "校友单位信息表",
    },
    component: () => import("@/views/alumniUnitForm/index.vue"),
  },
  {
    path: "/alumni/personal",
    name: "AlumniPersonalForm",
    meta: {
      title: "校友个人信息表",
    },
    component: () => import("@/views/alumniPersonalForm/index.vue"),
  },
  {
    path: "/alumni/personal/list",
    name: "AlumniPersonalList",
    meta: {
      title: "查看个人信息表",
    },
    component: () => import("@/views/alumniPersonalList/index.vue"),
  },
];

const router = new VueRouter({
  routes,
});

//路由卫士
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title}`;
  } else {
    document.title = "文通云";
  }
  if (to.meta.keepAlive) {
    if (store.getters.getKeepArr.indexOf(to.name) == -1) {
      // console.log("进入了");
      store.commit("setKeepArr", to.name);
      // store.state.common.keepArr.push(to.name);
    }
  }
  next();
});

export default router;
